import { useCallback } from 'react';
import {
  createProfileTrackPlaySession,
  recordProfileTrackPlay,
} from '../services/mediaService';
import { useTrackPlaybackSource } from '../store/TrackPlaybackContext';

export default function useProfileTrackPlayback({
  userId,
  subjectId,
  audience = 'viewer',
  sourceType = 'profile',
  tracks = [],
  createTrackPlaySession = createProfileTrackPlaySession,
  recordTrackPlay = recordProfileTrackPlay,
  onPlaysCountChange,
  onError,
  errorMessage = 'Unable to play this track.',
  logLabel = 'profile track',
  sourceLabel = '',
  sourceSubtitle = '',
  sourceImage = null,
} = {}) {
  const isPublicAudience = audience === 'public';
  const resolvedCreateTrackPlaySession = useCallback((targetId, objectKey) => (
    isPublicAudience
      ? createTrackPlaySession(targetId, objectKey, { audience: 'public' })
      : createTrackPlaySession(targetId, objectKey)
  ), [createTrackPlaySession, isPublicAudience]);
  const resolvedRecordTrackPlay = useCallback((targetId, objectKey, playSessionId) => (
    isPublicAudience
      ? recordTrackPlay(targetId, objectKey, playSessionId, { audience: 'public' })
      : recordTrackPlay(targetId, objectKey, playSessionId)
  ), [isPublicAudience, recordTrackPlay]);

  return useTrackPlaybackSource({
    sourceType,
    subjectId: subjectId || userId,
    queue: tracks,
    createTrackPlaySession: resolvedCreateTrackPlaySession,
    recordTrackPlay: resolvedRecordTrackPlay,
    onPlaysCountChange,
    onError,
    errorMessage,
    logLabel,
    sourceLabel,
    sourceSubtitle,
    sourceImage,
  });
}
